<template>
    <div ref="container" class="container">

        <header class='text-center mt-3'>
            <div class="header-icon header-icon--profile"></div>
            <!-- <img src="/img/egl/patient-standard2.svg" alt="profile icon"> -->
            <h1 class="h2 mb-3 mt-3">{{ $route.params.action ? $t('translations.who_is_this_service_for') : autobrand('translations.people_i_care_for') }}</h1>
            <p class="alert-warning alert mt-4">{{ autobrand('translations.content_requests_submit_someone_else_visible')}}</p>
        </header>

        <div class="d-flex flex-column">
            <template v-if='$root.user && $root.user.carees && $root.user.carees.length > 0'>
                <p class="m-2 alert alert-warning" v-if='!isServiceAvailable()'>
                    <template v-if='$root.provider.network_service_status == 0'>
                        {{autobrand('translations.network_is_currently_unavailable_for_online_requests')}}
                    </template>
                    <template v-else>
                        {{ serviceAvailabliltyMessage() }}
                    </template>
                </p>
                <div :key='relationship.id' v-for='relationship in $root.user.carees' class="mb-3">
                    <button v-on:click='(isServiceAvailable() || (isOohUnavailable() && outOfHoursCustomActions().length)) ? goNext(relationship) : false' class="card-button w-100 d-flex">
                        <div class="card-icon">
                            <svg x="0px" y="0px" viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve" class="icon-white">
                            <g>
                                <path d="M16.7,13.6l2.3,1c1.8,0.8,3,2.6,3,4.6V20c0,0.6-0.4,1-1,1s-1-0.4-1-1v-0.8
                                    c0-1.2-0.7-2.3-1.8-2.8l-3.6-1.5c-0.5-0.2-0.7-0.8-0.5-1.3c0.1-0.2,0.2-0.3,0.3-0.4c0.8-0.6,1.3-1.6,1.4-2.6L16,7.3
                                    c0.2-2.2-1.5-4.1-3.7-4.3c-0.1,0-0.2,0-0.3,0C9.8,3,8,4.8,8,7c0,0.1,0,0.2,0,0.3l0.2,3.3c0.1,1,0.6,2,1.4,2.6
                                    c0.1,0.1,0.2,0.2,0.3,0.4c0.2,0.5,0,1.1-0.5,1.3l-3.6,1.5C4.7,16.9,4,18,4,19.2V20c0,0.6-0.4,1-1,1s-1-0.4-1-1v-0.8
                                    c0-2,1.2-3.8,3-4.6l2.3-1c-0.6-0.8-1-1.8-1-2.9L6,7.4C6,7.3,6,7.1,6,7c0-3.3,2.7-6,6-6c0.1,0,0.3,0,0.4,0c3.3,0.2,5.8,3.1,5.5,6.4
                                    l-0.2,3.3C17.7,11.8,17.3,12.8,16.7,13.6L16.7,13.6z"/>
                            </g>
                            </svg>
                        </div>
                        <div>
                            <h2>{{formatNameCompliant(relationship)}}</h2>
                            <p><small>{{ relationship.dob | formatDate }}</small></p>
                        </div>
                    </button>
                </div>
            </template>
            <button v-on:click='registerProxy()' class="card-button mb-5">
                <div class="card-icon">
                    <svg x="0px" y="0px" viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve" class="icon-white">
                        <g>
                            <path d="M10,0c5.5,0,10,4.5,10,10c0,0.2,0,0.4,0,0.7c2.4,1.1,4,3.5,4,6.3c0,3.9-3.1,7-7,7
                                c-2.8,0-5.2-1.6-6.3-4l-0.3,0l0,0L10,20C4.5,20,0,15.5,0,10S4.5,0,10,0z M17,12c-2.8,0-5,2.2-5,5s2.2,5,5,5s5-2.2,5-5
                                S19.8,12,17,12z M17,14c0.6,0,1,0.4,1,1v1h1c0.6,0,1,0.4,1,1s-0.4,1-1,1h-1v1c0,0.6-0.4,1-1,1s-1-0.4-1-1v-1h-1c-0.6,0-1-0.4-1-1
                                s0.4-1,1-1h1v-1C16,14.4,16.4,14,17,14z M10,2c-4.4,0-8,3.6-8,8s3.6,8,8,8c0,0,0,0,0.1,0c0-0.3-0.1-0.7-0.1-1c0-3.9,3.1-7,7-7
                                c0.3,0,0.7,0,1,0.1l0-0.1C18,5.6,14.4,2,10,2z M10.1,3.6c2.4,0,4.4,2,4.4,4.4l0,0v0.6c0,0.5-0.4,0.9-0.9,0.9S12.7,9,12.7,8.5l0,0
                                V7.9c0-1.4-1.1-2.6-2.6-2.6l0,0H10c-1.3,0-2.4,1.1-2.4,2.4l0,0V9c0,1.1,0.5,2.1,1.3,2.9C9.1,12.2,9.2,12.6,9,13
                                c-0.1,0.3-0.3,0.5-0.5,0.6l0,0l-2.4,0.8c-0.4,0.1-0.9-0.1-1-0.5c-0.1-0.4,0.1-0.9,0.5-1l0,0l1.3-0.5c-0.7-1-1.1-2.1-1.1-3.4l0,0
                                V7.8c0-2.3,1.9-4.2,4.2-4.2l0,0H10.1z"/>
                        </g>
                    </svg>
                </div>
                <div>
                    <h2>{{ $t('translations.someone_else') }}</h2>
                    <p><small>{{ tBrandKey('add_another_person') }}</small></p>
                </div>

            </button>
        </div>

        <!-- <div v-else class="card-default">
            <template v-if='$root.user && $root.user.carees && $root.user.carees.length > 0'>
                <p class="m-2 alert alert-warning" v-if='!isServiceAvailable()'>
                    <template v-if='$root.provider.network_service_status == 0'>
                        {{autobrand('translations.network_is_currently_unavailable_for_online_requests')}}
                    </template>
                    <template v-else>
                        {{ serviceAvailabliltyMessage() }}
                    </template>
                </p>
                <ul :key='relationship.id' v-for='relationship in $root.user.carees' class="list-group list-group-flush mb-3">
                    <li class="list-group-item">{{formatNameCompliant(relationship)}} <button v-if='isServiceAvailable() || (isOohUnavailable() && outOfHoursCustomActions().length)' v-on:click='goNext(relationship)' class="btn btn-round btn-sm btn-primary float-right">
                        {{ ($route.params.action ? $t('select') : autobrand('translations.new_request')) | capitalise }}
                    </button></li>
                </ul>
            </template>
            <button v-on:click='registerProxy()' class="btn btn-round btn-block btn-primary">{{ tBrandKey('add_another_person') }}</button>

        </div> -->
    </div><!--ref:container-->


</template>

<script>
var moment = require('moment');
export default {
    props: [
    ],
    data: function(){
        return {

        }
    },
    mounted() {

    },
    methods: {
        initForm(action_id, user_id) {
            var data = {
                action_id: action_id,
                user_id: user_id
            }
            axios.post(this.$root.apiBase + "/formsubmissions/existing_or_new_from_custom_action", data).then((res) => {
                app.$root.$router.push({path: "/form-submission/" + res.data.id});
                
            }).catch((error) => {
                this.setLoading(false);
                this.handleError(error, "create");
            });
        },

        goNext(user) {
            if(this.$route.params.action_id) {
                this.initForm(this.$route.params.action_id, user.id);
            }
            else {
                this.$router.push({name: 'proxySelectAction', params: {user_id: user.id}});
            }
        },

        registerProxy() {
            this.$router.push({name: 'RegisterProxy', params: {action: this.$route.params.action, action_id: this.$route.params.action_id}});
        }
    }
}
</script>
